import { uiSurface } from "shared/ui/uiSurface"
import {
  Box,
  Breadcrumbs,
  styled,
  Typography,
} from "@mui/material"
import { FC, ReactNode } from "react"
import { Link as RouterLink } from "react-router"

import { useGetAllTagsQuery } from "../apis/appApi"
import { appConstants } from "../appConstants"
import { MainAppbar } from "./MainAppbar"

const StyledContentContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  marginTop: `${appConstants.mainAppBarHeight}px`,
  height: `calc(100vh - ${appConstants.mainAppBarHeight}px)`,
  overflowY: "auto",
}))

export interface BreadcrumbItem {
  label: string
  path?: string
}

export const MainLayout: FC<{
  children: ReactNode
  breadcrumbs?: BreadcrumbItem[]
}> = ({ children, breadcrumbs }) => {
  useGetAllTagsQuery()

  return (
    <Box {...uiSurface("UI-DLV2-004")} sx={{ bgcolor: "grey.50", minHeight: "100vh" }}>
      <MainAppbar />

      <StyledContentContainer>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Box sx={{ px: 3, py: 2, borderBottom: 1, borderColor: "divider" }}>
            <Breadcrumbs aria-label="breadcrumb">
              {breadcrumbs.map((crumb, index) => {
                const isLast = index === breadcrumbs.length - 1
                return isLast ? (
                  <Typography key={index} color="text.primary">
                    {crumb.label}
                  </Typography>
                ) : (
                  <RouterLink key={index} to={crumb.path || "#"}>
                    {crumb.label}
                  </RouterLink>
                )
              })}
            </Breadcrumbs>
          </Box>
        )}
        {children}
      </StyledContentContainer>
    </Box>
  )
}
